import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import { RiShareForwardLine } from "react-icons/ri";
import { FaWhatsapp } from "react-icons/fa";
import { MdOutlinePhone } from "react-icons/md";
import { HiVolumeUp, HiVolumeOff } from "react-icons/hi";
import { IoClose } from "react-icons/io5";
import { SlArrowLeft, SlArrowRight } from "react-icons/sl";
import "./HomeReelSection.css";
import SharePopUp from "../sharepopup/sharepopup";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, autoPlay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

// ── Arrows ───────────────────────────────────────────────────────
const NextArrow = ({ onClick }) => (
  <div className="hrs-arrow hrs-arrow--next" onClick={onClick}>
    <SlArrowRight />2.
  </div>
);
const PrevArrow = ({ onClick }) => (
  <div className="hrs-arrow hrs-arrow--prev" onClick={onClick}>
    <SlArrowLeft />
  </div>
);

// ── YouTube embed helper ─────────────────────────────────────────
const getEmbedURL = (url, muted) => {
  if (!url) return "";
  let videoId = "";
  if (url.includes("youtube.com/shorts/")) videoId = url.split("shorts/")[1].split("?")[0];
  else if (url.includes("watch?v=")) videoId = url.split("watch?v=")[1].split("&")[0];
  else if (url.includes("youtu.be/")) videoId = url.split("youtu.be/")[1].split("?")[0];
  else return url;
  return `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=${muted ? 1 : 0}&controls=0&playsinline=1&loop=1&playlist=${videoId}`;
};

const isYouTube = (src) =>
  src && (src.includes("youtube.com") || src.includes("youtu.be"));

// ── Single Phone Card ────────────────────────────────────────────
const OverlayPhoneCard = ({ reel, isActive, onShareClick }) => {
  const [muted, setMuted] = useState(true);
  const videoRef = React.useRef(null);


  // ✅ ADD THIS EFFECT
  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    if (isActive) {
      video.play().catch(() => { });
    } else {
      video.pause();
      video.currentTime = 0; // optional (reset video)
    }
  }, [isActive]);

  const toggleMute = () => {
    setMuted((prev) => {
      if (videoRef.current) videoRef.current.muted = !prev;
      return !prev;
    });
  };

  return (
    <div className={`ovl-phone ${isActive ? "ovl-phone--active" : "ovl-phone--side"}`}>

      {/* ── Full-bleed video ── */}
      <div className="ovl-video-wrap">

        {/* Video / iframe / image */}
        {isYouTube(reel.src) ? (
          <iframe
            key={`yt-${isActive}-${muted}`}
            src={isActive ? getEmbedURL(reel.src, muted) : ""}
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen
            className="ovl-media"
            style={{ pointerEvents: "none" }}
            title={reel.label}
          />
        ) : reel.src ? (
          <video
            ref={videoRef}
            src={reel.src}
            poster={reel.poster}
            autoPlay={isActive}
            muted={muted}
            playsInline
            loop
            className="ovl-media"
          />
        ) : (
          <img
            src={reel.poster || "/assets/homepageicons/DummyImage.png"}
            alt={reel.label}
            className="ovl-media"
          />
        )}

        {/* ── Top-left: Mute button ── */}
        <button
          className="ovl-btn ovl-mute-btn"
          onClick={toggleMute}
          title={muted ? "Unmute" : "Mute"}
        >
          {muted ? <HiVolumeOff size={18} /> : <HiVolumeUp size={18} />}
        </button>

        {/* ── Top-right: Phone · WhatsApp · Share ── */}
        <div className="ovl-top-right">
          <button
            className="ovl-btn"
            onClick={() => window.location.href = `tel:${reel.phone}`}
            title="Call"
          >
            <MdOutlinePhone size={18} />
          </button>
          <button
            className="ovl-btn"
            onClick={() => window.open(`https://wa.me/${reel.whatsapp}`, "_blank")}
            title="WhatsApp"
          >
            <FaWhatsapp size={18} />
          </button>
          <button
            className="ovl-btn"

            onClick={(e) => {
              e.stopPropagation();
              onShareClick(reel.src);
            }}
            title="Share"
          >
            <RiShareForwardLine size={18} />
          </button>
        </div>

        {/* ── Bottom: Frosted glass info box ── */}
        <div className="ovl-info-box">
          {/* Two-colour title: first word one colour, rest another */}
          <p className="ovl-info-title">
            {(() => {
              const words = (reel.label || "").split(" ");
              const first = words[0];
              const rest = words.slice(1).join(" ");
              return (
                <>
                  <span className="ovl-title-accent">{first}</span>
                  {rest && <span className="ovl-title-main"> {rest}</span>}
                </>
              );
            })()}
          </p>

          {reel.description && (
            <p className="ovl-info-desc">{reel.description}</p>
          )}
          <button
            className="ovl-enquire-btn"
            onClick={() => (window.location.href = "/contact-us")}
          >
            ENQUIRY NOW
          </button>
        </div>

      </div>{/* end video wrap */}
    </div>
  );
};

// ── ReelOverlay ──────────────────────────────────────────────────
const ReelOverlay = ({ reels = [], startIndex = 0, onClose, shareurl }) => {
  const [currentIndex, setCurrentIndex] = useState(startIndex);
  const [showShare, setShowShare] = useState(false);
  const [currentShareUrl, setCurrentShareUrl] = useState("");

  const handleShareClick = (url) => {
    setCurrentShareUrl(url);
    setShowShare(true);
  };
  useEffect(() => {
    document.body.classList.add("modal-open");

    return () => {
      document.body.classList.remove("modal-open");
    };
  }, []);
  useEffect(() => {
    if (showShare) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
  }, [showShare]);

  const settings = {
    dots: false,
    infinite: true,
    speed: 400,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "0px",
    initialSlide: startIndex,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    beforeChange: (_, next) => setCurrentIndex(next),
    responsive: [
      { breakpoint: 768, settings: { slidesToShow: 3, centerMode: true, centerPadding: "0px" } },
      { breakpoint: 576, settings: { slidesToShow: 1, centerMode: true, centerPadding: "0px" } },
    ]
  };

  return (<>
    <div className="ovl-backdrop" onClick={onClose}>
      <div className="ovl-modal" onClick={(e) => e.stopPropagation()}>

        {/* Close */}
        <button className="ovl-close-btn" onClick={onClose}>
          <IoClose size={20} />
        </button>

        <div className="ovl-slider-wrap">
          <Swiper
            modules={[Navigation]}
            centeredSlides={true}
            slidesPerView={3}
            spaceBetween={20}
            loop={true}
            initialSlide={startIndex}
            onSlideChange={(swiper) => setCurrentIndex(swiper.realIndex)}
            navigation={{
              nextEl: ".custom-next2",
              prevEl: ".custom-prev2",
            }}
            breakpoints={{
              0: { slidesPerView: 1 },
              576: { slidesPerView: 1 },
              768: { slidesPerView: 3 },
            }}
            className="ovl-swiper"
          >
            {reels.map((reel, i) => (
              <SwiperSlide key={i} className="ovl-slide">
                <OverlayPhoneCard
                  reel={reel}
                  isActive={i === currentIndex}
                  onShareClick={handleShareClick}
                />
              </SwiperSlide>
            ))}
          </Swiper>
          <div className="custom-prev2 hrs-arrow2 hrs-arrow--prev">
            <SlArrowLeft />
          </div>

          <div className="custom-next2 hrs-arrow2 hrs-arrow--next">
            <SlArrowRight />
          </div>
        </div>

      </div>
    </div>
    {/* Share popup */}
    {showShare && (
      <div
        className="hrs-share-backdrop"
        onClick={() => setShowShare(false)}
      >
        <div onClick={(e) => e.stopPropagation()}>
          <SharePopUp
            title="Share"
            shareurl={currentShareUrl || window.location.href}
            showmail
            showwhatsapp
            showfacebook
            showLinkedin
            onClose={() => setShowShare(false)}
          />
        </div>
      </div>
    )}
  </>);
};

export default ReelOverlay;